import ReviewCard from "@/components/sections/review/ReviewCard";

export default function ReviewCTA({ t }) {
  return (
    <section
      id="reviews"
      className="py-20 sm:py-28 bg-white border-y border-[var(--border)]"
      data-testid="reviews-section"
    >
      <div className="max-w-5xl mx-auto px-6 sm:px-10">
        <ReviewCard t={t} />
      </div>
    </section>
  );
}
